/* Angular Component */
import { Component, Output, Input, EventEmitter } from "@angular/core";

@Component({
  selector: "ichannel-textarea",
  templateUrl: "./textarea.component.html",
  styleUrls: ["./textarea.component.scss"],
})
export class TextareaComponent {
  @Input()
  value;

  @Output()
  output = new EventEmitter();

  @Input()
  label;

  @Input()
  placeholder;

  @Input()
  inputType = "text";

  @Input()
  maxLength: number = null;

  itemId;

  ngOnInit() {
    this.generateId();
  }

  /**
   * Generating a unique id based on place holder and time zone (provided for label)
   * @return void
   */
  generateId() {
    if (!this.placeholder) return new Date().getTime();

    this.itemId = this.placeholder.replace(/\s/g, "-") + new Date().getTime();
  }

  /**
   * Updating Out the value
   * @return void
   */
  update() {
    this.output.emit(this.value);
  }
}
